import InjectLocale from './injectLocale';

export default InjectLocale;